export default {"src":"/_next/static/media/PersonalId_NationalId.52cb6abb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};